import { reactive } from "vue";

export const loadingState = reactive({
  isLoading: false,
  isRouteLoading: false,
  loadingMessage: "Loading...",
});
